// extracted by mini-css-extract-plugin
export default {"editButton":"fixedDeduction_editButton__RulBs","TableBody":"fixedDeduction_TableBody__5237v","deleteButton":"fixedDeduction_deleteButton__xM2Ia"};